<div id="searchBase">
    <app-header [headerTitle]="'home.searchVoucher' | translate" [navBack]="'true'" [accessActions]="false"></app-header>

    <div class="searchField">
        <div class="baseContainer">            
            <input type="text" [(ngModel)]="toSearchFor" [placeholder]="'home.searchVoucher' | translate" (keyup.enter)="doSearch()"><span (click)="doSearch()"><i class="fas fa-search"></i></span>
        </div>
    </div>

    <div class="results baseContainer">
        <h6>{{ 'home.results' | translate }}</h6>

        
        <main>

            <a *ngFor="let voucher of Results" class="voucher">
                <img [src]="voucher.image" [alt]="voucher.name">
                <span [class.hided]="!voucher.discountLabel" [innerHTML]="voucher.discountLabel || '-'"></span>
                <b>{{ voucher.name }}</b>
                <p [innerHTML]="voucher.priceLabel"></p>
            </a>

            <h5 *ngIf="Results && Results.length <= 0" class="text-center py-5 my-5">{{ 'home.noVoucherFound' | translate }}</h5>

            <div *ngIf="!Results" class="contentLoader my-5 py-5"><span></span></div>

        </main>

    </div>

</div>